/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Tarjeta_Proyectos_Home from "../Tarjetas/Tarjeta_Proyectos_Home";
import proyecto1 from '../../../../Recursos/proyecto1.png'
import proyecto2 from '../../../../Recursos/proyecto2.png'
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";

const proyectos = [
    {
        imagen: proyecto1,
        title: 'Iniciativa de Desarrollo Asocargan',
        parrafo: 'Asocargan impulsa el desarrollo empresarial y social a través de capacitación, asesoría y apoyo en áreas clave como el transporte de carga, promoción de causas públicas, bienestar laboral y gestión empresarial.'
    },
    {
        imagen: proyecto2,
        title: 'Iniciativa de Desarrollo Asocargan',
        parrafo: 'Asocargan impulsa el desarrollo empresarial y social a través de capacitación, asesoría y apoyo en áreas clave como el transporte de carga, promoción de causas públicas, bienestar laboral y gestión empresarial.'
    }
]

const Lista_Tarjeta_Proyectos_Home = () => {
    const [proyectos, setProyectos] = useState([])


    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({coleccion: 'proyectos', wheres: w}).then((dox) => {
            if (dox.res) {
                setProyectos(dox.data)
            }
        })
    }, []);
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            spacing={8}
            size={12}>

            {proyectos.map((item, index) => (

                <Grid2 container size={12}>
                    <Tarjeta_Proyectos_Home
                        item={item}/>
                </Grid2>

            ))}
        </Grid2>
    )

}
export default Lista_Tarjeta_Proyectos_Home